(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["spotify-embed"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spotify-embed-player')) {
    customElements.define(
      'spotify-embed-player',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('button')?.addEventListener('click', () => this.load(), { once: true });
        }

        load() {
          const iframe = document.createElement('iframe');
          iframe.src = this.dataset.src;
          iframe.title = 'Spotify';
          iframe.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
          iframe.loading = 'lazy';
          this.replaceChildren(iframe);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
